
const AdminChatIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 30 30" fill="none">
            <rect width="30" height="30" rx="15" fill="#0152FB" />
            <path d="M13.47 18.2551C13.47 19.4932 12.4615 20.4968 11.2174 20.4968C9.97336 20.4968 8.96484 19.4932 8.96484 18.2551C8.96484 17.0171 9.97336 16.0134 11.2174 16.0134C12.4615 16.0134 13.47 17.0171 13.47 18.2551Z" fill="white" />
            <path d="M13.1565 12.79C12.5553 11.7304 12.9311 10.3865 13.9958 9.78825C15.0605 9.18999 16.411 9.56396 17.0122 10.6235L20.7483 17.2085C21.3495 18.2681 20.9737 19.612 19.909 20.2103C18.8443 20.8085 17.4938 20.4346 16.8926 19.375L13.1565 12.79Z" fill="white" />
        </svg>
    )
}

export default AdminChatIcon